import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Avatar,
} from "@mui/material";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import YesNo from "./components/YesNo";
import Range from "./components/Range";
import PreferredAgeRange from "./components/PreferredAgeRange";
import CommLog from "./components/CommLog";
import UserOrders from "../UserOrders";
import Choice from "./components/Choice";
import request from "../../utilities/requests";
import { EventContext } from "../../contexts/EventContext";
import { toast } from "../../utilities/SnackBarUtils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditProfileDialog = ({ open, close, user, eventId }) => {
  const { userData } = React.useContext(EventContext);
  const inputFile = React.useRef(null);
  const [profile, setProfile] = React.useState({});
  const [name, setName] = React.useState({ first: "", last: "" });
  const [imageUrl, setImageUrl] = React.useState(null);
  const [questions, setQuestions] = React.useState([]);
  const [registrationStatus, setRegistrationStatus] = React.useState(null);

  React.useEffect(() => {
    if (user) {
      setProfile(user.profile);
      getProfilePic(user._id);
      getQuestions(eventId, user._id);
      getRegistrationStatus(user.email);
      setName({
        first: user?.profile?.firstName || "",
        last: user?.profile?.lastName || "",
      });
    }
  }, [user]);

  const getProfilePic = async (userId) => {
    const result = await request(`profile/photo?userId=${userId}`);
    if (result.success) {
      setImageUrl(result.url);
    }
  };

  const getRegistrationStatus = async (email) => {
    const result = await request(
      `users/checkregistration?email=${encodeURIComponent(email)}`,
    );
    if (result.success) {
      setRegistrationStatus(result);
    }
  };

  const getQuestions = async (eventId, userId) => {
    const url = `profilequestions/byevent?eventId=${eventId}&userId=${userId}`;
    const result = await request(url);
    if (result.success) {
      setQuestions(result?.profileQuestions);
    }
  };
  const handleUpload = async (event) => {
    const file = event.target.files[0];
    const body = new FormData();
    body.append("photo", file);
    body.append("Content-Type", "image/jpg");
    body.append("userId", user._id);
    const token = localStorage.getItem(
      `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`,
    );
    // setLoading(true);
    axios({
      url: `${process.env.REACT_APP_TNFT_SERVER}/profile/photo`,
      method: "post",
      data: body,
      headers: { "Content-Type": "multipart/form-data", Accesstoken: token },
    })
      .then(() => {
        getProfilePic(user._id);
      })
      .catch((e) => {
        console.error(`Error uploading profile picture: ${e.message}`);
      });
  };

  const renderQuestions = () => {
    return questions.map((question) => {
      if (question.variant === "preferredAge") {
        return (
          <PreferredAgeRange
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (question.questionType === "yesno") {
        return (
          <YesNo
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (
        question.questionType === "choice" ||
        question.questionType === "multipleChoice"
      ) {
        return (
          <Choice
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (
        question.questionType === "related" &&
        question.choices.length > 0
      ) {
        return (
          <Choice
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (
        question.questionType === "related" &&
        question.choices.length === 0
      ) {
        return (
          <YesNo
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (question.questionType === "range") {
        return (
          <Range
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      }
    });
  };

  const handleChange = async (id, answer) => {
    const body = { userId: user._id, questionId: id, answer };
    const result = await request("profilequestions/answer", "post", body);
    if (result.success) {
      const qs = questions.map((question) => {
        if (question._id === id) {
          return { ...question, answer };
        }
        return question;
      });
      setQuestions(qs);
      toast.success("Profile updated successfully");
    }
  };

  const handleNameChange = (field, value) => {
    let n = name;
    n[field] = value;
    setName({ ...n });
  };

  const handleConfirm = async () => {
    const body = {
      userId: user._id,
    };
    const result = await request("users/confirmuser", "post", body);
    if (result.success) {
      toast.success("User confirmed!");
    }
  };

  const handleSave = async () => {
    let body = { userId: user._id, firstName: name.first, lastName: name.last };
    let result = await request("profile/adminupdate", "post", body);
    if (result.success) {
      toast.success("Profile updated successfully");
      close();
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={close}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Edit Event Profile
            </Typography>

            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container spacing={3} style={{ padding: 20 }}>
          <Grid item xs={12}>
            <Grid container direction="row">
              <Grid
                item
                style={{ display: "flex", justifyContent: "center" }}
                xs={6}
              >
                <Avatar
                  src={imageUrl}
                  style={{ height: 120, width: 120 }}
                  onClick={() => inputFile.current.click()}
                />
                <input
                  type="file"
                  id="file"
                  ref={inputFile}
                  style={{ display: "none" }}
                  onChange={handleUpload}
                />
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: 10,
                }}
                xs={6}
              >
                {" "}
                {registrationStatus ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="button">Registered:</Typography>

                      {registrationStatus?.registered ? (
                        <CheckIcon style={{ color: "#68C371" }} />
                      ) : (
                        <CloseIcon style={{ color: "#E36262" }} />
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="button">Confirmed:</Typography>

                      {registrationStatus?.confirmed ? (
                        <CheckIcon style={{ color: "#68C371" }} />
                      ) : (
                        <CloseIcon style={{ color: "#E36262" }} />
                      )}
                    </div>
                    {userData?.role === "superadmin" &&
                      registrationStatus?.confirmed && (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleConfirm}
                        >
                          Confirm User
                        </Button>
                      )}
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Grid>
          <CommLog user={user} />
          {userData?.permissions?.canManageOrders ||
          userData?.role === "superadmin" ? (
            <UserOrders user={user} />
          ) : null}
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              spacing={3}
            >
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  value={user ? user.email : ""}
                  variant="filled"
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  value={user ? user.phone : ""}
                  variant="filled"
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item>
              <TextField
                // variant={textFieldVariant}
                fullWidth
                label="First Name"
                value={name?.first ? name.first : ""}
                onChange={(e) => handleNameChange("first", e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item>
              <TextField
                // variant={textFieldVariant}
                fullWidth
                label="Last Name"
                value={name?.last ? name.last : ""}
                onChange={(e) => handleNameChange("last", e.target.value)}
              />
            </Grid>
          </Grid>

          {renderQuestions()}

          <Grid item xs={12}>
            <Button
              variant="outlined"
              onClick={handleSave}
              style={{ width: "100%" }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default EditProfileDialog;
